<template>
  <ion-page>
    <ion-header class="header-container">
      <ion-toolbar class="header-toolbar">
        <ion-searchbar
          v-model="searchValue"
          class="header-search"
          placeholder="Find a cafe"
          @keyup.enter="search"
        ></ion-searchbar>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <div class="favorites-div">
        <!--<CategoryButtons name="CategoryButtons" />-->
        <span class="h1-search">Recent searches</span>
        <ion-row style="flex-wrap: nowrap; overflow: hidden; max-height: 70px">
          <ion-col size="12">
            <div v-for="search in searches" :key="search.id">
              <ion-button class="recent" @click="runSearch(search)">
                {{ search }}
              </ion-button>
            </div>
          </ion-col>
        </ion-row>
        <hr class="sep-div" />
        <CoffeeShopCard :cafes="cafes" />
      </div>
    </ion-content>
    <TheFooter name="TheFooter" />
  </ion-page>
</template>
<style scoped>
/* Header Container */
.header-container {
  --background: #f87e63;
}

.header-toolbar {
  --background: #f87e63;
  --border-width: 0;
  --padding-top: 8px;
  --padding-bottom: 8px;
  --padding-start: 16px;
  --padding-end: 16px;
  --min-height: 64px;
}

/* Search Bar */
.header-search {
  --background: #ffffff;
  --color: #1b1b1b;
  --placeholder-color: #828282;
  --icon-color: #1b1b1b;
  --clear-button-color: #828282;
  --border-radius: 8px;
  --box-shadow: none;
  --cancel-button-color: transparent;
  font-family: "Gilroy", sans-serif;
  font-size: 14px;
  font-weight: 500;
  padding: 0;
  margin: 0;
}

/* Content Styles */
.h1-search {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  color: #1b1b1b;
  margin-top: 20px;
  margin-bottom: 15px;
  margin-left: 15px;
}

.favorites-div {
  padding: 5%;
}
ion-button.recent {
  --background: #f3f3f3;
  --background-hover: #dce8ff;
  --background-activated: #dce8ff;
  --background-focused: #dce8ff;
  --color: #666666;
  --border-radius: 8px;
  --border-color: #f3f3f3;
  --border-style: solid;
  --border-width: 1px;
  --ripple-color: #dce8ff;
  --padding: 8px 16px;
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  margin-top: 15px;
  margin-right: 15px;
  text-transform: none;
  --box-shadow: none;
  width: auto;
}
.sep-div {
  border-bottom: 1px solid #f3f3f3;
  margin-bottom: 20px;
}
</style>
<script>
import axios from "axios";
import { defineComponent } from "vue";
import CoffeeShopCard from "@/components/CoffeeShopCard.vue";
import TheFooter from "@/components/TheFooter.vue";
import {
  IonContent,
  IonIcon,
  IonPage,
  IonRow,
  IonCol,
  IonLabel,
  IonInput,
  IonButton,
  IonSearchbar,
  IonToolbar,
  IonHeader,
  IonButtons,
} from "@ionic/vue";

const BASE_URI =
  process.env.VUE_APP_BASE_URI !== undefined
    ? process.env.VUE_APP_BASE_URI
    : "https://api.onecoffeeapp.com.au";

export default defineComponent({
  name: "SearchPage",
  components: {
    IonContent,
    IonIcon,
    IonPage,
    IonRow,
    IonCol,
    IonLabel,
    IonInput,
    IonButton,
    IonSearchbar,
    IonToolbar,
    IonHeader,
    IonButtons,
    CoffeeShopCard,
    TheFooter,
  },
  data() {
    return {
      searchValue: "",
      searches: [],
      cafes: [],
      userId: "",
    };
  },
  created() {
    this.userId = localStorage.getItem("id") || null;

    // Always load recent searches
    this.getRecentSearches();

    if (this.$route.query.q) {
      this.searchValue = this.$route.query.q;
      this.search();
    }
  },
  methods: {
    async getRecentSearches() {
      this.searches = [];

      // Check if user is logged in
      const token = localStorage.getItem("token");
      const isLoggedIn = token !== null && token !== "null" && token !== "";

      if (!isLoggedIn) {
        // User not logged in, don't fetch searches
        return;
      }

      let paramsData = {
        userId: this.userId,
      };

      let axiosConfig = {
        headers: {
          Authorization: token,
          "Content-Type": "application/json;charset=UTF-8",
        },
        params: paramsData,
      };

      try {
        let result = await axios.get(
          BASE_URI + "/search/get-searches",
          axiosConfig
        );

        result.data.data.forEach((element) => {
          this.searches.push(element.keyword);
        });
      } catch (error) {
        console.error("Failed to load recent searches:", error);
        // Gracefully degrade - leave searches empty
      }
    },

    async search() {
      // Check if user is logged in
      const token = localStorage.getItem("token");
      const isLoggedIn = token !== null && token !== "null" && token !== "";

      let paramsData = {
        isDeleted: "0",
        q: this.searchValue,
      };

      let axiosConfig = {
        headers: {
          Authorization: token,
          "Content-Type": "application/json;charset=UTF-8",
        },
        params: paramsData,
      };

      let result = await axios.get(
        BASE_URI + "/cafe/get-coffee-shops-with-details",
        axiosConfig
      );

      // Transform API response to match CoffeeShopCard component expectations
      this.cafes = result.data.data.map((cafe) => ({
        uuid: cafe.cafeId,
        shopName: cafe.name,
        shopImgUrl: cafe.image,
        address: cafe.address,
        rating: cafe.rating,
        reviews: cafe.reviews,
        details: cafe.details,
        isOpen: cafe.isOpen,
        businessHours: cafe.businessHours,
      }));

      // Only save search keyword if user is logged in
      if (isLoggedIn) {
        paramsData = {
          userId: this.userId,
          keyword: this.searchValue,
        };

        axiosConfig = {
          headers: {
            Authorization: token,
            "Content-Type": "application/json;charset=UTF-8",
          },
        };

        try {
          await axios.post(
            BASE_URI + "/search/create-searches",
            paramsData,
            axiosConfig
          );
        } catch (error) {
          console.error("Failed to save search keyword:", error);
          // Gracefully degrade - don't block the search flow
        }
      }
    },

    async handleKeyPress(event) {
      if (event.keyCode === 13) {
        await this.search();
      }
    },

    runSearch(searchValue) {
      this.searchValue = searchValue;
      this.getRecentSearches();
      this.search();
    },
  },
});
</script>
